import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import {Button, Input} from "@headlessui/react";
import {useDarkMode} from "../../contexts/darkModeContext";

const StepperInput = ({
  value,
  onChange,
  step = 0.5,
  min = 0,
  max,
  disabled = false,
  placeholder = "",
  className = "",
}) => {
    
        const { darkMode } = useDarkMode();

  const handleIncrement = () => {
    if (disabled) return;
    const newValue = (parseFloat(value) || 0) + step;
    if (max !== undefined && newValue > max) return;
    onChange(newValue);
  };

  const handleDecrement = () => {
    if (disabled) return;
    const newValue = (parseFloat(value) || 0) - step;
    if (newValue < min) return;
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    onChange(val === "" ? "" : parseFloat(val));
  };

  return (
    <div
      className={`flex items-center rounded-md border h-full ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:border-green-500"
      } ${darkMode ? 'border-neutral-700 bg-darkMainColor' : 'bg-white'} overflow-hidden ${className}`}
    >
      
      {/* Decrease */}
      <Button
        type="button"
        onClick={handleDecrement}
        disabled={disabled}
        className={`px-2 py-1 flex items-center ${darkMode ? 'bg-white/5' : 'bg-black/5'} h-full justify-center ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-100/10'}`}
      >
        <MinusIcon className="w-4 h-4" />
      </Button>

      {/* Input */}
      <Input
        type="number"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={true}
        className="w-full h-full text-center bg-transparent text-xs focus:outline-none"
      />

      {/* Increase */}
      <Button
        type="button"
        onClick={handleIncrement}
        disabled={disabled}
        className={`px-2 py-1 flex items-center ${darkMode ? 'bg-white/5' : 'bg-black/5'} h-full justify-center ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-100/10'}`}
      >
        <PlusIcon className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default StepperInput;
